import router from "./../router";
export default {
  foo() {
    return "foo";
  },
  resizeIframeEvent() {
    let height = document.body.scrollHeight;
    global.event.$emit("height_change", height);
  },
  updateColorAccordingApi() {
    global.event.$emit("update_root_color");
  },
  isWebDevice() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      return false;
    }
    return true;
  },
  b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || "";
    sliceSize = sliceSize || 512;

    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  },
  validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  },
  urltoFile(url, filename, mimeType) {
    return fetch(url)
      .then(function(res) {
        return res.arrayBuffer();
      })
      .then(function(buf) {
        return new File([buf], filename, { type: mimeType });
      });
  },
  send_tracking_data(params , base_url) {
    // console.log(params, this.$session.get('baseUrl'))
    let query = "?";
    query += Object.keys(params)
      .map((key) => key + "=" + params[key])
      .join("&");
    let send = new Image();
    send.src = `${base_url}/pixel-track/${query}`;
  },
  get_ip() {
    /* Return the ip from session store if any */
    if (sessionStorage.getItem("user_ip") && sessionStorage.getItem("user_ip") != "") {
      return sessionStorage.getItem("user_ip");
    } else {
      let xmlHttp = new XMLHttpRequest();
      xmlHttp.open("GET", "https://api.ipify.org", false);
      xmlHttp.send(null);
      let ip = xmlHttp.responseText;
      /* Set it to the session storage to avoid multiple requests to this website */
      sessionStorage.setItem("user_ip", ip);
      return ip;
    }
  },
  get_location_data(ip) {
    let xmlHttp = new XMLHttpRequest();
    xmlHttp.open("GET", `https://www.iplocate.io/api/lookup/${ip}`, false);
    xmlHttp.send(null);
    /* Try and get details from the response */
    try {
      let response = JSON.parse(xmlHttp.responseText);
      let user_location = JSON.stringify({
        city: response.city,
        country: response.country,
        country_code: response.country_code,
      });
      /* Set it to the session storage to avoid multiple requests to this website */
      sessionStorage.setItem("user_location", user_location);
      return user_location;
    } catch (error) {
      console.log(error);
      return false;
    }
  },
  moveToSelectedOption(option_unique_id, option_question_id, fromAdmin) {
    if (option_unique_id && option_question_id && !fromAdmin) {
      router.push({
        name: "QuestionView",
        params: {
          id: option_unique_id,
          qid: option_question_id,
        },
      });
    }
  },
  makeScreensInxes(data) {
  // console.log(data);
    let array = [];
    // array[0] = { screen: "launcherScreen", data: {} };
    array[0] = { screen: "profile", data: {} };
    array[1] = { screen: "feedback", data: {} };
    if (data.options && data.options.length) {
      for (let index = 0; index < data.options.length; index++) {
        if (data.options[index].questions) {
          for (let i = 0; i < data.options[index].questions.length; i++) {
            let tempQuestion = data.options[index].questions[i];
            tempQuestion.option_unique_id = data.options[index].option_unique_id;
            array[array.length] = { screen: "questions", data: tempQuestion };
          }
        }
        array[array.length] = { screen: "collections", data: {} };
        array[array.length] = { screen: "thanksPage", data: {} };
      }
    }
    array[array.length] = { screen: "launcherScreen", data: {} };
    return array;
  },
};
